import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {ArrayResponse, SendBackResult, serializeQueryString} from '../../shared';
import {AppSettingsService} from '../../shared/services/app-settings.service';
import {BaseRestService} from '../../shared/services/base-rest.service';
import {Site} from '../../shared/models/site';
import {SiteFilter} from '../models/site-filter';
import {DUMMY_ARRAY_RESPONSE_LICENCES, DUMMY_ARRAY_RESPONSE_PROGRAMS} from '../../dummy-site';
import {CommonField} from '../../shared/models/common-field';
import {SubscriptionI} from '../../shared/models/subscription-i';
import {AddPlayer} from '../models/add-player';
import {Player} from '../../shared/models/player';
import {Subscription} from '../../order/models/order-form';
import {AnomaliesCountListItem} from '../../anomaly/models/anomalies-count-list-item';
import {Concept} from '../../shared/models/concept';

@Injectable({ providedIn: 'root' })
export class SitesService extends BaseRestService {

  constructor(http: HttpClient, appSettingsService: AppSettingsService) {
    super(http, appSettingsService);
  }

  protected get className(): string {
    return 'SitesService';
  }

  protected get isAnonymous(): boolean {
    return false;
  }

  getList(clientId: string, filter: SiteFilter): Observable<SendBackResult<ArrayResponse<Site>>> {
    if (clientId) {
      return this.get<ArrayResponse<Site>>(`/clients/${clientId}/sites${serializeQueryString(filter)}`);
    }

  }


  load(clientUuid: string, siteUuid: string): Observable<SendBackResult<Site>> {
    // console.log('LoadSiteMultiAction cc', clientUuid)
    // console.log('LoadSiteMultiAction ss', siteUuid)
    return this.get<Site>(`/clients/${clientUuid}/sites/${siteUuid}`);
  }

  update(clientUuid: string, sub: SubscriptionI): Observable<SendBackResult<Site>> {
    return this.put<Site>(`/clients/${clientUuid}/sites/${sub.uuid}`, sub);
  }

  // old api
  updateSubSite(clientUuid: string, subscription: SubscriptionI, siteUUID: string): Observable<SendBackResult<SubscriptionI>> {
    return this.put<SubscriptionI>(`/clients/${clientUuid}/sites/${siteUUID}/subscriptions/${subscription.uuid}`, subscription);
  }

  add(clientUuid: string, site: Site): Observable<SendBackResult<Site>> {
    return this.post<Site>(`/clients/${clientUuid}/sites`, site);
  }

  getLicences(clientUUID: string, siteUUID: string): Observable<SendBackResult<ArrayResponse<CommonField>>> {
    // return this.get<CommonField>(`/clients/${clientUuid}/sites/licences`);
    return of(DUMMY_ARRAY_RESPONSE_LICENCES); // TODO: replace by api
  }

  getPrograms(clientUUID: string, siteUUID: string): Observable<SendBackResult<ArrayResponse<CommonField>>> {
    // return this.get<CommonField>(`/clients/${clientUuid}/sites/licences`);
    return of(DUMMY_ARRAY_RESPONSE_PROGRAMS); // TODO: replace by api
  }

  loadMany(sitesUuid: { uuid: string }[]): Observable<SendBackResult<Site[]>> {
    return this.post<Site[]>(`/sites/many`, sitesUuid);
  }

  // tslint:disable-next-line:no-any
  patchPart(api: string, clientUUID: string, siteUUID: string, subscriptionUUID: string, data: any)
    : Observable<SendBackResult<SubscriptionI>> {
    // console.log('SitesService' , api)
    switch (api) {
      case 'site': {
        return this.patch<SubscriptionI>(`/clients/${clientUUID}/sites/${siteUUID}/subscriptions/${subscriptionUUID}/patch/site`, data);
        break;
      }
      case 'subscription': {
        return this.patch<SubscriptionI>(`/clients/${clientUUID}/sites/${siteUUID}/subscriptions/${subscriptionUUID}/patch/subscription`, data);
        break;
      }
      case 'serverForm': {
        return this.patch<SubscriptionI>(`/clients/${clientUUID}/sites/${siteUUID}/subscriptions/${subscriptionUUID}/patch/server`, data);
        break;
      }
      case 'videoOption': {
        return this.patch<SubscriptionI>(`/clients/${clientUUID}/sites/${siteUUID}/subscriptions/${subscriptionUUID}/patch/video`, data);
        break;
      }
      case 'commentsForm': {
        return this.patch<SubscriptionI>(`/clients/${clientUUID}/sites/${siteUUID}/subscriptions/${subscriptionUUID}/patch/comments`, data);
        break;
      }
      case 'ipAddress': {
        return this.patch<SubscriptionI>(`/clients/${clientUUID}/sites/${siteUUID}/subscriptions/${subscriptionUUID}/patch/ipAddress`, data);
        break;
      }
      case 'proxy': {
        return this.patch<SubscriptionI>(`/clients/${clientUUID}/sites/${siteUUID}/subscriptions/${subscriptionUUID}/patch/proxy`, data);
        break;
      }
      case 'wifi': {
        return this.patch<SubscriptionI>(`/clients/${clientUUID}/sites/${siteUUID}/subscriptions/${subscriptionUUID}/patch/wifi`, data);
        break;
      }
      case 'address': {
        return this.patch<SubscriptionI>(
          `/clients/${clientUUID}/sites/${siteUUID}/subscriptions/${subscriptionUUID}/patch/address/${data.addressType}`, data
        );
        break;
      }
      case 'contact': {
        return this.patch<SubscriptionI>(`/clients/${clientUUID}/sites/${siteUUID}/subscriptions/${subscriptionUUID}/patch/contact`, data);
        break;
      }
      case 'concepts': {
        return this.post<SubscriptionI>(`/clients/${clientUUID}/sites/${siteUUID}/subscriptions/${subscriptionUUID}/Concepts`, {'concepts':  data.concepts});
        break;
      }
      default: {
        return null;
        break;
      }
    }
  }
  getConceptBySubscription(clientUuid: string, siteUuid: string, subscriptionUuid: string): Observable<SendBackResult<ArrayResponse<Concept>>> {
    return this.get<ArrayResponse<Concept>>(`/clients/${clientUuid}/sites/${siteUuid}/subscriptions/${subscriptionUuid}/Concepts`);
  }

  addDevice(clientUuid: string, siteUuid: string, subscriptionUuid: string, addPlayer: AddPlayer): Observable<SendBackResult<Player>> {
    return this.post<Player>(`/clients/${clientUuid}/sites/${siteUuid}/subscriptions/${subscriptionUuid}/add-player`, addPlayer);
  }

  // tslint:disable-next-line:no-any
  merge(clientUuid: string, merge: any): Observable<any> {
    return this.post<Player>(`/clients/${clientUuid}/Sites/move`, merge);
  }
  // tslint:disable-next-line:no-any
  mergeSubscription(clientUuid: string, merge: any): Observable<any> {
    return this.post<Player>(`/clients/${clientUuid}/Subscription/move`, merge);
  }


  // tslint:disable-next-line:no-any
  bulk_update_status(clientUuid: string, data: any): Observable<SendBackResult<Site>> {
    return this.put<Site>(`/clients/${clientUuid}/Bulk/update/status`, data);
  }
}
